module.exports = __webpack_public_path__ + "img/1490356754.befe8c7b.jpg";